const CONFIG_GENERAL = {
    DEFAULT_LANG: process.env.REACT_APP_DEFAULT_LANG || "vi",
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
};

const parseJsonEnv = (value, fallback = {}) => {
    if (!value) return fallback;
    try {
        return JSON.parse(value);
    } catch (e) {
        return fallback;
    }
};

const AD_INFO = parseJsonEnv(process.env.REACT_APP_AD_INFO, {});
if (AD_INFO && AD_INFO.INFO && AD_INFO.INFO.auth) {
    if (!AD_INFO.INFO.auth.postLogoutRedirectUri) {
        AD_INFO.INFO.auth.postLogoutRedirectUri = window.location.origin;
    }
    if (!AD_INFO.INFO.auth.redirectUri) {
        AD_INFO.INFO.auth.redirectUri = window.location.origin;
    }
}

const CONFIG = {
    ...CONFIG_GENERAL,
    ENV: process.env.REACT_APP_ENVIRONMENT || "development",
    API_CMS: process.env.REACT_APP_API_CMS || "",
    API_IDENTITY: process.env.REACT_APP_API_IDENTITY || "",
    API_HOTEL: process.env.REACT_APP_API_HOTEL || "",
    API_HOMESTAY: process.env.REACT_APP_API_HOMESTAY || "",
    API_TOUR: process.env.REACT_APP_API_TOUR || "",
    API_CONTENT: process.env.REACT_APP_API_CONTENT || "",
    API_ORDER: process.env.REACT_APP_API_ORDER || "",
    API_VOUCHER: process.env.REACT_APP_API_VOUCHER || "",
    API_FLIGHT: process.env.REACT_APP_API_FLIGHT || "",
    API_PROMOTION: process.env.REACT_APP_API_PROMOTION || "",
    API_PAYMENT: process.env.REACT_APP_API_PAYMENT || "",
    API_REPORT: process.env.REACT_APP_API_REPORT || "",
    API_TOUR_V2: process.env.REACT_APP_API_TOUR_V2 || "",
    API_GOLF: process.env.REACT_APP_API_GOLF || "",
    HOTEL_TENANT_ID: process.env.REACT_APP_HOTEL_TENANT_ID || "",
    HOMESTAY_TENANT_ID: process.env.REACT_APP_HOMESTAY_TENANT_ID || "",
    GOOGLE_RECAPTCHA_SITE_KEY: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY || "",
    SENTRY_KEY: process.env.REACT_APP_SENTRY_KEY || "",
    SENTRY_PROJECT: process.env.REACT_APP_SENTRY_PROJECT || "",
    AD_INFO,
    // API Client Credentials
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID || "",
    CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET || "",
};

export default CONFIG;
